import axios from "axios";

const API = axios.create({
    baseURL:
        process.env.REACT_APP_API_URL ||
        "http://localhost:3001/api",
    headers: {
        "Content-Type": "application/json"
    }
});

/* ================================
   REQUEST INTERCEPTOR (ATTACH TOKEN)
================================ */
API.interceptors.request.use((req) => {

  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token");

  const isLoginRequest =
    req.url === "/auth/login";

  if (token && !isLoginRequest) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});
   

/* ================================
   RESPONSE INTERCEPTOR (AUTO LOGOUT)
================================ */
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      console.warn("🔒 Unauthorized (401) → logging out user");

      localStorage.removeItem("token");
localStorage.removeItem("user");

sessionStorage.removeItem("token");
sessionStorage.removeItem("user");

      // prevent redirect loops
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default API;